<script>
  export let text = "";

  $: badgeClass = `change_badge_${text.trim().toLowerCase().replace(/\s+/g, "_")}`;
</script>

<span class={`change_badge ${badgeClass}`}>{text}</span>

<style>
  .change_badge {
    align-items: center;
    border-radius: 999px;
    color: var(--pax-black);
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 400;
    height: 1.5rem;
    padding: 0 0.55rem;
    white-space: nowrap;
  }

  .change_badge_removed {
    background: #e6a7ad;
  }

  .change_badge_added {
    background: #b7e3bd;
  }

  .change_badge_changed {
    background: #e5e8a8;
  }

  .change_badge_layout_changed {
    background: #abcfe8;
  }
</style>
